<template>
  <div class="text-center max-w-5xl mx-auto mb-12">
    <h3 class="my-6 text-xl flex items-center">
      <button
        class="mr-auto p-2 transition hover:bg-gray-200 active:bg-gray-300 disabled:opacity-20 disabled:pointer-events-none"
        :disabled="loading"
        @click.prevent="onSwitchToPrevWeek">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <span class="h-14">
        <Spinner v-show="loading" class="mt-4" />
        <template v-if="!loading">
          KW {{ calendarWeek }} <br>
          <span class="text-black">
            {{ startOfWeekFormatted }} - {{ endOfWeekFormatted }}
          </span>
        </template>
      </span>
      <button
        class="ml-auto p-2 transition hover:bg-gray-200 active:bg-gray-300 disabled:opacity-20 disabled:pointer-events-none"
        :disabled="!canGoFurther || loading"
        @click.prevent="onSwitchToNextWeek">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </h3>
    <button
      class="text-xs hover:text-accent-brown"
      :class="{'pointer-events-none opacity-30': inSameWeek}"
      :disabled="inSameWeek || loading"
      @click="resetToCurrentWeek">zurück zur aktuellen Woche</button>
  </div>
</template>

<script>
import subWeeks from 'date-fns/subWeeks'
import addWeeks from 'date-fns/addWeeks'
import startOfWeek from 'date-fns/startOfWeek'
import isSameWeek from 'date-fns/isSameWeek'
import endOfWeek from 'date-fns/endOfWeek'
import getWeek from 'date-fns/getWeek'
import getYear from 'date-fns/getYear'
import format from 'date-fns/format'
import deLocale from 'date-fns/locale/de'
import differenceInWeeks from 'date-fns/differenceInWeeks'

import Spinner from '@/Components/Spinner'

export default {
  name: "WeekNavigation",
  components: { Spinner },

  props: {
    selected: {
      type: Date,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    now: new Date(),
  }),

  computed: {
    startOfWeek() {
      return startOfWeek(this.selected, { weekStartsOn: 1 })
    },

    inSameWeek() {
      return isSameWeek(this.now, this.selected)
    },

    endOfWeek() {
      return endOfWeek(this.selected, { weekStartsOn: 1 })
    },

    startOfWeekFormatted() {
      return format(this.startOfWeek, 'dd. MMM', {
        locale: deLocale
      })
    },

    endOfWeekFormatted() {
      return format(this.endOfWeek, 'dd. MMM yyyy', {
        locale: deLocale
      })
    },

    calendarWeek() {
      return getWeek(this.selected, { weekStartsOn: 1, locale: deLocale })
    },

    selectedYear() {
      return getYear(this.selected)
    },

    canGoFurther() {
      return differenceInWeeks(this.now, this.selected) >= 0
    }
  },

  methods: {
    onSwitchToPrevWeek() {
      this.$emit(
        'update',
        subWeeks(startOfWeek(this.selected, { weekStartsOn: 1 }), 1)
      )
    },

    onSwitchToNextWeek() {
      this.$emit(
        'update',
        addWeeks(startOfWeek(this.selected, { weekStartsOn: 1 }), 1)
      )
    },

    resetToCurrentWeek() {
      this.$emit(
        'update',
        startOfWeek(
          this.now, { weekStartsOn: 1 }
        )
      )
    }
  }
}
</script>
